import { http } from "../index";
import Config from "../config/config";

const UseNotification = () => {

  const readUserNotification = (id) => {
    return http.post({
      url: Config.User.Notifications.Read.replace("{id}", id),
    });
  };

  const readFeeChangeMessage = (id) => {
    return http.post({
      url: Config.User.Notifications.ReadFeeChange.replace("{id}", id),
    });
  };

  const readSmsAddsMessage = (id) => {
    return http.post({
      url: Config.User.Notifications.smsAdds.replace("{value}", id),
    });
  };

  return { readUserNotification,readFeeChangeMessage,readSmsAddsMessage };
};

export default UseNotification;
